import {
  Anchor,
  SimpleGrid,
    useMantineTheme,
    Title,
    Center,
  Box
} from '@mantine/core';
import { Link } from 'react-router-dom';
import { UserExclamation, Lock, Devices, Login, SquarePlus, QuestionMark } from 'tabler-icons-react';

import { DashboardPanel } from './components/DashboardPanel';

interface Dashboard {
  title: string;
  description: string;
}

const Dashboard = () => {

    const theme = useMantineTheme();
  
    return (
        <Box>
            <Center><Title my="lg" order={1}> How Can We Help You?</Title></Center>
    <SimpleGrid
            cols={3}
            
      breakpoints={[
        { maxWidth: 980, cols: 3, spacing: 'md' },
        { maxWidth: 755, cols: 2, spacing: 'sm' },
        { maxWidth: 600, cols: 1, spacing: 'sm' },
      ]}
            >
            <Anchor component={Link} to={`/incident-request`}>  
                <DashboardPanel title="Incident Ticket" description="Something isn't working correctly, or something is broken." icon={<UserExclamation />} gradient1={theme.colors.lime[5]} gradient2={theme.colors.green[5]} iconColour="lime" />
            </Anchor>
            <Anchor component={Link} to={`/new-access-ticket`}>
                <DashboardPanel title="Access Request or Problem" description="Add, change, or remove access." icon={<Login />} gradient1={theme.colors.grape[6]} gradient2={theme.colors.violet[9]} iconColour="grape" />
            </Anchor>

            <Anchor component={Link} to={`/change-password`}>
                <DashboardPanel title="Passwords" description="Change or reset your password." icon={<Lock />} gradient1={theme.colors.yellow[5]} gradient2={theme.colors.orange[5]} iconColour="yellow" />
            </Anchor>
            <DashboardPanel title="IT Service Request" description="Request IT Service - changes to applications, training, reports, projects." icon={<SquarePlus />} gradient1={theme.colors.gray[3]} gradient2={theme.colors.gray[6]} iconColour="gray" />
            <Anchor component={Link} to={`/device-request`}>
            <DashboardPanel title="Device Request" description="Request a replacement or new device." icon={<Devices />} gradient1={theme.colors.orange[6]} gradient2={theme.colors.orange[9]} iconColour="orange" />
            </Anchor>
       
    {/*    <DashboardPanel title="Question / Information / Other" description="Have a question that isn't covered by any of the other buttons? Fill out this form and we will get back to*/}
    {/*you, or direct your ticket to the right place." icon={<QuestionMark />} gradient1={theme.colors.blue[2]} gradient2={theme.colors.blue[5]} iconColour="blue"/>*/}
            </SimpleGrid>
        </Box>
  );
};

export default Dashboard;
